export default __webpack_public_path__ + "static/media/A0005.66793e70.png";